import { useCallback } from 'react';
import { defineMessage } from 'react-intl';

import { Cryptocurrency } from '__generated__/globalTypes';
import { useIntlContext } from 'contexts/intl';
import { isAddress } from 'lib/ethereum';
import { isSolanaAddress } from 'lib/solana';

import { TextField, Props as TextFieldProps } from '../TextField';

type Props = TextFieldProps & {
  cryptocurrency: Cryptocurrency;
};

const invalidAddressMessages = {
  [Cryptocurrency.WEI]: 'Ethereum',
  [Cryptocurrency.LAMPORT]: 'Solana',
};

const invalidAddress = defineMessage({
  id: 'Notification.invalidAddress',
  defaultMessage: 'Invalid {cryptocurrency} address',
});

const validators = {
  [Cryptocurrency.WEI]: isAddress,
  [Cryptocurrency.LAMPORT]: isSolanaAddress,
};

export const CryptoAddressField = ({ cryptocurrency, ...props }: Props) => {
  const { formatMessage } = useIntlContext();

  const validateCryptoAddress = useCallback(
    (value: string) => {
      if (!validators[cryptocurrency](value)) {
        return formatMessage(invalidAddress, {
          cryptocurrency: invalidAddressMessages[cryptocurrency],
        });
      }
      return null;
    },
    [formatMessage, cryptocurrency]
  );

  return (
    <TextField
      {...props}
      type="text"
      validate={validateCryptoAddress}
      autoComplete="off"
    />
  );
};
